import styled from "styled-components";

const INPUT = styled.input`
  border: none;
  display: flex;
  border-bottom: 1px solid black;
`;

export default INPUT;
